//#region src/kiosk_preview_mode.ts
const KioskPreviewMode = {
	Demo: "demo",
	Live: "live"
};
//#endregion
export { KioskPreviewMode };

//# sourceMappingURL=kiosk_preview_mode.js.map